// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"PreviewProfileLayout_footerWrapper__A_3gm"};